import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x21800000 {
  commandID: number;
  fileName: string;
  posit: number;
  size: number;
}

export function Command0x21800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    commandID: 0,
    fileName: "",
    posit: 0,
    size: 0,
  };

  const [fields, setFields] = React.useState<Form0x21800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x21800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.commandID) {
      params.commandID = 0;
    }
    if (!params.fileName) {
      params.fileName = "";
    }
    if (!params.posit) {
      params.posit = 0;
    }
    if (!params.size) {
      params.size = 0;
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          inputProps={{ min: 0 }}
          id="commandID"
          label="ID запроса"
          margin="dense"
          fullWidth
          value={fields.commandID}
          onChange={handleChangeField("commandID")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          id="fileName"
          label="Имя файла “12345678.123” (если имя короче, то 0 на конце)"
          margin="dense"
          fullWidth
          value={fields.fileName}
          onChange={handleChangeField("fileName")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          inputProps={{ min: 0 }}
          id="posit"
          label="Смещение"
          margin="dense"
          fullWidth
          value={fields.posit}
          onChange={handleChangeField("posit")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          inputProps={{ min: 0 }}
          id="size"
          label="Сколько байт читать (не более 512)"
          margin="dense"
          fullWidth
          value={fields.size}
          onChange={handleChangeField("size")}
        />
      </FormControl>
    </>
  );
}
